// extracted by mini-css-extract-plugin
export default {"container":"style_container__pU1-w","editing":"style_editing__YIn6F","box":"style_box__mG8lR","buttons":"style_buttons__ZWdg3"};